import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import {
  Grid,
  IconButton,
  Typography,
  Divider,
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  Dialog,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import CommonButton from "../../../../components/CustomComponents/Buttons/bulkButton";

const useStyles = makeStyles((theme) => ({
  headingText: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#495059",
  },
  headingTextGrid: {
    marginBottom: "10px",
  },
  mainHeadingContainer: {
    paddingTop: "10px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "20px",
  },
  mainKeyWordContainer: {
    paddingTop: "15px",
  },
  textFieldContainer: {
    paddingTop: "15px",
    display: "flex",
  },
  weekDaysContainer: {
    paddingTop: "20px",
    paddingBootom: "20px",
  },
  labelText: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1B2430",
    paddingBottom: "8px",
  },
  titleText: {
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#1B2430",
  },
  errorText: {
    color: "#d32f2f",
    marginTop: "3px",
    // marginLeft: "14px",
    fontSize: "0.6964285714285714rem",
  },
  helpingText: {
    color: "#c0c0c0",
    marginTop: "3px",
    marginLeft: "14px",
    fontSize: "0.6964285714285714rem",
  },
  textFieldTypoRight: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "28px",
    color: "#181818",
    paddingRight: "8px",
    paddingTop: "5px",
  },
  textFieldTypoLeft: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "28px",
    color: "#181818",
    paddingLeft: "8px",
    paddingTop: "5px",
  },

  calenderContainer: {
    border: "1px solid #E0E0E0",
    borderRadius: "8px",
    padding: "12px",
    marginTop: "12px",
  },
  calenderContainerError: {
    border: "1px solid #d32f2f",
    borderRadius: "8px",
    padding: "12px",
    marginTop: "12px",
  },
  calenderLabelContainer: {
    height: "30px",
    padding: "5px",
    cursor: "pointer",
    textAlign: "center",
    margin: "3px",
  },
  calenderLabel: {
    textAlign: "center",
    fontWeight: 700,
  },
  checkboxContainer: {
    borderRadius: "8px",
    marginTop: "12px",
  },

  checkboxTypo: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#181818",
    paddingTop: "9px",
  },
}));

const PostCustomModel = ({
  title,
  onCancel,
  open,
  frequencyValue,
  setFrequencyValue,
  occuranceValue,
  setOccuranceValue,
  selectedWeekDays,
  setSelectedWeekDays,
  selectedMonthDays,
  setSelectedMonthDays,
  repeat,
  data,
  setOpenCustomModel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [occuranceError, setOccuranceError] = useState(false);
  // const [monthError, setMonthError] = useState(false);
  // const [weekError, setWeekError] = useState(false);
  const [frequencyTempValue, setFrequencyTempValue] = useState("");
  const [occuranceTempValue, setOccuranceTempValue] = useState(1);
  const [selectedWeekTempDays, setSelectedWeekTempDays] = useState([]);
  const [selectedMonthTempDays, setSelectedMonthTempDays] = useState([]);

  useEffect(() => {
    if (open === true) {
      const frequency = frequencyValue === "" ? "daily" : frequencyValue;
      const occurance = occuranceValue;
      const weekDays = JSON.parse(JSON.stringify(selectedWeekDays));
      const monthDays = JSON.parse(JSON.stringify(selectedMonthDays));

      setFrequencyTempValue(frequency);
      setOccuranceTempValue(occurance);
      setSelectedWeekTempDays(weekDays);
      setSelectedMonthTempDays(monthDays);
    }
  }, [open]);

  useEffect(() => {
    if (frequencyValue === "monthly") {
      handleCheckErrorMonth();
    }
  }, [selectedMonthDays]);
  useEffect(() => {
    if (frequencyValue === "weekly") {
      handleCheckErrorWeek();
    }
  }, [selectedWeekDays]);

  const weekArr = [
    {
      name: "sun",
      label: t("sun"),
      value: 0,
    },
    {
      name: "mon",
      label: t("mon"),
      value: 1,
    },
    {
      name: "tue",
      label: t("tue"),
      value: 2,
    },
    {
      name: "wed",
      label: t("wed"),
      value: 3,
    },
    {
      name: "thu",
      label: t("thu"),
      value: 4,
    },
    {
      name: "fri",
      label: t("fri"),
      value: 5,
    },
    {
      name: "sat",
      label: t("sat"),
      value: 6,
    },
  ];
  const monthArr = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  ];
  const handleClickWeekDays = (selectedDay) => {
    if (selectedWeekTempDays?.includes(selectedDay?.value)) {
      const filtered = selectedWeekTempDays?.filter(
        (item) => item !== selectedDay?.value
      );
      const sortedArrayDescending = filtered.slice().sort((a, b) => a - b);
      setSelectedWeekTempDays(sortedArrayDescending);
    } else {
      selectedWeekTempDays?.push(selectedDay?.value);
      const sortedArrayDescending = selectedWeekTempDays
        .slice()
        .sort((a, b) => a - b);
      setSelectedWeekTempDays([...sortedArrayDescending]);
    }
    //  handleCheckError("week");
  };

  const handleClickWeekDaysForSubmit = () => {
    const sortedArrayDescending = selectedWeekTempDays
      .slice()
      .sort((a, b) => a - b);
    setSelectedWeekDays([...sortedArrayDescending]);
    //  handleCheckError("week");
  };

  const handleClickMonthDays = (selectedDay) => {
    let objjj = JSON.stringify(selectedMonthTempDays);
    let temmpArray = JSON.parse(objjj);
    // let temmpArray = [...selectedMonthDays];
    if (temmpArray?.includes(selectedDay)) {
      const filtered = temmpArray?.filter((item) => item !== selectedDay);
      const sortedArrayDescending = filtered.slice().sort((a, b) => a - b);
      setSelectedMonthTempDays(sortedArrayDescending);
      // handleCheckError("month");
    } else {
      temmpArray?.push(selectedDay);
      const sortedArrayDescending = temmpArray.slice().sort((a, b) => a - b);
      setSelectedMonthTempDays([...sortedArrayDescending]);
      //   handleCheckError("month");
    }
  };

  const handleClickMonthDaysForSumbit = () => {
    const sortedArrayDescending = selectedMonthTempDays
      .slice()
      .sort((a, b) => a - b);
    setSelectedMonthDays([...sortedArrayDescending]);
    //   handleCheckError("month");
  };

  const handleCheckErrorMonth = () => {
    /*   if (selectedMonthDays?.length === 0) {
      setMonthError(true);
    } else {
      setMonthError(false);
    } */
  };
  const handleCheckErrorWeek = () => {
    /*   if (selectedWeekDays?.length === 0) {
      setWeekError(true);
    } else {
      setWeekError(false);
    } */
  };

  const handleSubmit = () => {
    setFrequencyValue(frequencyTempValue);
    setOccuranceValue(occuranceTempValue);
    if (frequencyTempValue === "monthly") {
      handleClickMonthDaysForSumbit();
    } else if (frequencyTempValue === "weekly") {
      handleClickWeekDaysForSubmit();
    }
    setOpenCustomModel(false);
    //  onCancel();
    setTimeout(() => {
      setFrequencyTempValue("daily");
      setOccuranceTempValue(1);
      setSelectedWeekTempDays([]);
      setSelectedMonthTempDays([]);
    }, 500);
  };

  return (
    <Dialog
      open={open}
      maxHeight
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "400px",
          // height: "480px",
        },
      }}
    >
      <DialogTitle>
        <Grid container>
          <Grid item xs={11} sm={11} md={11} lg={11}>
            <Typography className={classes.titleText}>{title}</Typography>
          </Grid>

          <Grid
            item
            xs={1}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "flex-end", textAlign: "end" }}
          >
            <IconButton
              autoFocus
              onClick={onCancel}
              className="delete_button"
              sx={{ paddingTop: "0px" }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography className={classes.labelText}>
              {t("frequency")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={frequencyTempValue}
                onChange={(e) => {
                  setFrequencyTempValue(e.target.value);
                  setOccuranceTempValue(1);
                  setSelectedMonthTempDays([]);
                  setSelectedWeekTempDays([]);
                }}
                sx={{ width: "250px" }}
              >
                <MenuItem value="daily">{t("DailyText")}</MenuItem>
                <MenuItem value="weekly">{t("WeeklyText")}</MenuItem>
                <MenuItem value="monthly">{t("MonthlyText")}</MenuItem>
                {/* <MenuItem value="yearly">{t("YearlyText")}</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.textFieldContainer}>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <Typography className={classes.textFieldTypoRight}>
              {t("every")}
            </Typography>
          </Grid>
          <Grid item xs={2.5} sm={2.5} md={2.5} lg={2.5}>
            <TextField
              type="number"
              size="small"
              value={occuranceTempValue}
              inputProps={{
                type: "number",
                min: 1,
                step: 1,
              }}
              onChange={(event) => {
                setOccuranceTempValue(parseInt(event.target.value));
                if (event.target.value <= 0) {
                  setOccuranceError(true);
                } else {
                  setOccuranceError(false);
                }
              }}
              error={occuranceError}
              //  helperText={occuranceError && t("occurance_error_text")}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={3} sm={3} md={3} lg={3}>
            <Typography className={classes.textFieldTypoLeft}>
              {frequencyTempValue === "daily"
                ? occuranceTempValue > 1
                  ? t("days_text")
                  : t("days")
                : frequencyTempValue === "weekly"
                ? occuranceTempValue > 1
                  ? t("weekTexts")
                  : t("weekText")
                : frequencyTempValue === "monthly"
                ? occuranceTempValue > 1
                  ? t("months")
                  : t("month")
                : t("")}
            </Typography>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={12}>
            {occuranceError && (
              <Typography className={classes.errorText}>
                {t("occurance_error_text")}
              </Typography>
            )}
          </Grid> */}
        </Grid>
        {/* {frequencyValue !== "weekly" && frequencyValue !== "daily" && (
          <Grid container className={classes.checkboxContainer}>
            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <Checkbox
                sx={{ paddingLeft: "0px" }}
                checked={eachChecked}
                onChange={(e) => handleChangeCheckButton(e)}
              />
              <Typography className={classes.checkboxTypo}>
                {t("each")}
              </Typography>
            </Box>
          </Grid>
        )} */}
        {frequencyTempValue !== "daily" && frequencyTempValue !== "monthly" && (
          <Grid className={classes.weekDaysContainer}>
            <Grid container>
              {weekArr?.map((item) => {
                return (
                  <Grid
                    item
                    xs={1.4}
                    sm={1.4}
                    md={1.4}
                    lg={1.4}
                    className={classes.calenderLabelContainer}
                    sx={{
                      background: selectedWeekTempDays?.includes(item?.value)
                        ? "#06BDFF"
                        : "#FFF",
                      borderRadius: "12px",
                      border: selectedWeekTempDays?.includes(item?.value)
                        ? "1px solid #06BDFF"
                        : "1px solid #E0E0E0",
                    }}
                    onClick={() => handleClickWeekDays(item)}
                  >
                    <Typography
                      sx={{
                        color: selectedWeekTempDays?.includes(item?.value)
                          ? "#FFF"
                          : "#757D8A",
                        textAlign: "center",
                      }}
                    >
                      {item?.label}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        )}
        {/*   {weekError && frequencyValue === "weekly" && (
          <Typography className={classes.errorText}>
            {t("weekDays_error")}
          </Typography>
        )} */}

        {frequencyTempValue !== "daily" && frequencyTempValue !== "weekly" && (
          <Grid container className={classes.calenderContainer}>
            {monthArr?.map((item) => {
              return (
                <Grid
                  item
                  xs={1.1}
                  sm={1.1}
                  md={1.1}
                  lg={1.1}
                  className={classes.calenderLabelContainer}
                  sx={{
                    background: selectedMonthTempDays?.includes(item)
                      ? "#06BDFF"
                      : "#FFF",
                    borderRadius: "12px",
                    border: selectedMonthTempDays?.includes(item)
                      ? "1px solid #06BDFF"
                      : "1px solid #E0E0E0",
                  }}
                  onClick={() => handleClickMonthDays(item)}
                >
                  <Typography
                    className={classes.calenderLabel}
                    sx={{
                      color: selectedMonthTempDays?.includes(item)
                        ? "#FFF"
                        : "#757D8A",
                    }}
                  >
                    {item}
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
        )}
        {/*  {monthError && frequencyValue === "monthly" && (
          <Typography className={classes.errorText}>
            {t("monthDays_error")}
          </Typography>
        )} */}
      </DialogContent>
      <Divider />

      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Box sx={{ marginRight: "10px" }}>
          <CommonButton
            displayWhite="true"
            onSubmit={onCancel}
            // disabled={isSubmitting}
            label={t("Cancel")}
          />{" "}
        </Box>
        <Box>
          <CommonButton
            disabled={
              occuranceTempValue === 0 ||
              occuranceError ||
              (selectedMonthTempDays?.length === 0 &&
                frequencyTempValue === "monthly") ||
              (selectedWeekTempDays?.length === 0 &&
                frequencyTempValue === "weekly")
            }
            type="submit"
            label={t("Save")}
            onSubmit={handleSubmit}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default PostCustomModel;
